"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSpinner = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const Responsive_1 = require("../../shared/Responsive");
const getResponsiveSize = ({ $size = "medium", }) => {
    const mappingCss = {
        xsmall: {
            width: "12px",
            height: "12px",
            minWidth: "12px",
            minHeight: "12px",
        },
        small: {
            width: "24px",
            height: "24px",
            minWidth: "24px",
            minHeight: "24px",
        },
        medium: {
            width: "48px",
            height: "48px",
            minWidth: "48px",
            minHeight: "48px",
        },
        large: {
            width: "64px",
            height: "64px",
            minWidth: "64px",
            minHeight: "64px",
        },
    };
    return (0, Responsive_1.responsiveMapToMedia)($size, mappingCss);
};
const getResponsiveBorderWidth = ({ $size = "medium", }) => {
    const mappingCss = {
        xsmall: { borderWidth: "2px" },
        small: { borderWidth: "4px" },
        medium: { borderWidth: "6px" },
        large: { borderWidth: "8px" },
    };
    return (0, Responsive_1.responsiveMapToMedia)($size, mappingCss);
};
const color = {
    white: "var(--ds-color-white)",
    blue: "var(--ds-color-blue-100)",
};
exports.StyledSpinner = styled_components_1.default.span `
    display: block;

    /* dimension */
    ${getResponsiveSize}

    /* border */
    border-style: solid;
    border-radius: 50%;
    ${getResponsiveBorderWidth}

    /* color */
    ${({ $color = "blue" }) => {
    return (0, styled_components_1.css) `
            /* adds 25% transparency on color value */
            border-color: color-mix(in hsl, ${color[$color]} 25%, transparent);
            border-top-color: ${color[$color]};
        `;
}}

    /* rotation */
    animation: spin 0.75s ease-in-out infinite;
    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;
//# sourceMappingURL=Spinner.styles.js.map